import Bet from '../model/bet';

/**
 * Bet service
 * @type {{init: (function()), getBettingSvc: (function())}}
 */
export const BetSvc = {
  /**
   * Initialize bet service
   */
  init() {
    this.betSvc = new Bet();
  },

  /**
   * Get bet service
   * @returns {Bet | BetSvc}
   */
  getBetSvc() {
    return this.betSvc;
  },
};






// WEBPACK FOOTER //
// bet.service.js